// extracted by mini-css-extract-plugin
export default {"table":"Table_table__YUzYe","left":"Table_left__0Ng4m","actions":"Table_actions__zexxr","tableHeader":"Table_tableHeader__z1a2J","headerWrapper":"Table_headerWrapper__eLT5x"};